<template>
  <modal
    :name="$lang.messages.addBankAccountModal"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
    :delay="0.15"
    @before-close="handleCloseBankAccountModal"
  >

    <modals-header
      :modalNameProp="$lang.messages.addBankAccountModal"
      @hideModalProp="hideAddBankAccountModal"
    >
    </modals-header>

    <div class="fp-modal checkbook-modal" :class="{'step7-min-height':smallHeader,'centered-column':(smallHeader || step1)}">

     <div v-if="linkToken">
    <plaid-link
        v-bind="{
            env:plaid_env,
            onSuccess:onPublicTokenFetched,
            token: linkToken,
            onExit:onPublicTokenError,
            onEvent:handlePlaidOpenEvent
        }"
    >
      <template slot="button" slot-scope="props">
        <button ref="pladButton" id="plaidAddButton" type="button" class="action-btn plaid-button" :class="{'display-none': (hidePlaidButton || step5 || step6)}" 
          @click="handleClick(props.onClick,$event)">
          <span>{{ $lang.messages.instantAccountVerification }}</span>
        </button>
      </template>
    </plaid-link>
        </div>


      <!--Step 1 - choosing verification type-->
      <div class="checkbook-modal-step center" v-if="step1">
        <div class="iv-error-wrapper" v-if="linkTokenError">
        <button type="button" class="action-btn plaid-button disabled-iv-button" disabled>
          {{ $lang.messages.instantAccountVerification }}
        </button>
          <span class="text-center link-error-text">{{ $lang.messages.plaidErrorMessage }}</span>
        </div>
        <p>{{ $lang.messages.instantAccountVerificationText }}</p>
  
        <p class="text-uppercase or">{{ $lang.messages.or }}</p>
        
        <button type="button" class="action-btn" @click="chooseMV">
          <span>{{ $lang.messages.manuelVerification }}</span>
        </button>
        <p>{{ $lang.messages.manuelVerificationText }}</p>
      </div>

    <!-- Step 7 - Instant account verfication progress/success/error -->
    <div v-if="step7">
    <sweetalert-icon v-if="!bankLinkingLoading && !plaidError && !step7Start" icon="success" />
    <p class="plaid-success-text text-center" v-if="!bankLinkingLoading && !plaidError && !step7Start">{{$lang.messages.IAVBankAccountAdded}}</p>
    <sweetalert-icon v-if="bankLinkingLoading" icon="loading" />
    <sweetalert-icon v-if="!bankLinkingLoading && plaidError" icon="error" />
    <p class="plaid-error-text text-center" v-if="!bankLinkingLoading && plaidError">{{this.plaidError}}</p>
    </div>
  
      <!--Step 5 - Manuel verification -->
      <div class="checkbook-modal-step" v-if="step5">
        <div class="part img-part">
          <img src="@/assets/images/digital_check.png" alt="digital_check" />
        </div>
        
        <form autocomplete="off">
          <div class="part">
            <p class="label input-filter-label">
              {{ $lang.messages.accountType }}
              <span class="asterix">*</span>
            </p>
            <div class="wrapper">
              <autocomplete
                  :items="accountTypes"
                  :placeholder="$lang.messages.selectAccountType"
                  :option="selectedAccountType"
                  :name="'accountType'"
                  :scope="'addBankAccount'"
                  :key="rerender"
                  ref="autocompleteAccountType"
                  @clearInputErrors="clearInputErrors"
                  @clearOthers="clearOthers"
                  @optionChanged="onSelectAccountType"
              />
            </div>
          </div>
  
          <div class="part">
            <p class="label input-filter-label">
              {{ $lang.messages.routing }}
              <span class="asterix">*</span>
            </p>
            <div class="input-wrapper input-field" :class="{'error-input' : errors.has('addBankAccount.routing')}">
              <input
                  type="text"
                  name="routing"
                  autocomplete="off"
                  class="input"
                  :placeholder="$lang.messages.enterRouting"
                  v-model="routing"
                  data-vv-scope="addBankAccount"
                  v-validate="'required|min:9|max:9'"
                  @click.self="clearInputErrors($event)"
                  @focus.self="clearInputErrors($event)"
                  @blur="clearOthers($event)"
              />
              <img
                  src="@/assets/images/validation_ico.png"
                  alt=""
                  class="icon error-icon"
              />
              <div
                  v-show="errors.has('addBankAccount.routing')"
                  class="error-tooltip"
                  :class="{'hide-tooltip' : bluredProp !== 'routing'}"
              >
                <div class="text">
                  {{ errors.first('addBankAccount.routing') }}
                </div>
              </div>
            </div>
          </div>
  
          <div class="part">
            <p class="label input-filter-label">
              {{ $lang.messages.accountNumber }}
              <span class="asterix">*</span>
            </p>
            <div class="input-wrapper input-field" :class="{'error-input' : errors.has('addBankAccount.accountNumber')}">
              <input
                  type="text"
                  name="accountNumber"
                  autocomplete="off"
                  class="input"
                  :placeholder="$lang.messages.enterAccountNumber"
                  v-model="accountNumber"
                  data-vv-scope="addBankAccount"
                  v-validate="'required|min:1'"
                  @click.self="clearInputErrors($event)"
                  @focus.self="clearInputErrors($event)"
                  @blur="clearOthers($event)"
              />
              <img
                  src="@/assets/images/validation_ico.png"
                  alt=""
                  class="icon error-icon"
              />
              <div
                  v-show="errors.has('addBankAccount.accountNumber')"
                  class="error-tooltip"
                  :class="{'hide-tooltip' : bluredProp !== 'accountNumber'}"
              >
                <div class="text">
                  {{ errors.first('addBankAccount.accountNumber') }}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
  
      <!--Step 6 - Manuel verification entering amounts -->
      <div class="checkbook-modal-step" v-if="step6">
        <form autocomplete="off">
          <div class="part">
            <p class="label input-filter-label">
              {{ $lang.messages.microdeposit1 }}
              <span class="asterix">*</span>
            </p>
            <div class="input-wrapper input-field input-mask" :class="{'error-input' : errors.has('addBankAccount.mfaAmount1')}">
              <div class="mask">
                <currency-sign :currency="currency"></currency-sign>0.
              </div>
              <input
                  type="text"
                  name="mfaAmount1"
                  autocomplete="off"
                  class="input"
                  :placeholder="'00'"
                  v-model="mfaAmount1"
                  data-vv-scope="addBankAccount"
                  v-validate="'required|min:1'"
                  @click.self="clearInputErrors($event)"
                  @focus.self="clearInputErrors($event)"
                  @blur="clearOthers($event)"
              />
              <img
                  src="@/assets/images/validation_ico.png"
                  alt=""
                  class="icon error-icon"
              />
              <div
                  v-show="errors.has('addBankAccount.mfaAmount1')"
                  class="error-tooltip"
                  :class="{'hide-tooltip' : bluredProp !== 'mfaAmount1'}"
              >
                <div class="text">
                  {{ errors.first('addBankAccount.mfaAmount1') }}
                </div>
              </div>
            </div>
          </div>
  
          <div class="part">
            <p class="label input-filter-label">
              {{ $lang.messages.microdeposit2 }}
              <span class="asterix">*</span>
            </p>
            <div class="input-wrapper input-field input-mask" :class="{'error-input' : errors.has('addBankAccount.mfaAmount2')}">
              <div class="mask">
                <currency-sign :currency="currency"></currency-sign>0.
              </div>
              <input
                  type="text"
                  name="mfaAmount2"
                  autocomplete="off"
                  class="input"
                  :placeholder="'00'"
                  v-model="mfaAmount2"
                  data-vv-scope="addBankAccount"
                  v-validate="'required|min:1'"
                  @click.self="clearInputErrors($event)"
                  @focus.self="clearInputErrors($event)"
                  @blur="clearOthers($event)"
              />
              <img
                  src="@/assets/images/validation_ico.png"
                  alt=""
                  class="icon error-icon"
              />
              <div
                  v-show="errors.has('addBankAccount.mfaAmount2')"
                  class="error-tooltip"
                  :class="{'hide-tooltip' : bluredProp !== 'mfaAmount2'}"
              >
                <div class="text">
                  {{ errors.first('addBankAccount.mfaAmount2') }}
                </div>
              </div>
            </div>
          </div>
          
          <span class="description">
            {{ $lang.messages.microDepositInfo1 }}
          </span>
          <br><br>
          <span class="description">
          {{ $lang.messages.microDepositInfo2 }}
          </span>
        </form>
      </div>
      
      <div class="checkbook-modal-footer" :class="{'w-100':smallHeader}">
        <f-p-button-loader v-if="!step1 && !step7" :loading="loading" :text="$lang.messages.preferences_next" @click.native="nextStep" ></f-p-button-loader>
        <button
            v-if="!step1 && !bankLinkingLoading && !step7Start"
            type="button"
            class="generic-btn"
            @click="hideAddBankAccountModal"
        >
          {{this.step7?$lang.messages.capitalizedClose: $lang.messages.cancel }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { GET_BANK_INSTITUTIONS, CHECKBOOK_LOGIN_TO_BANK, CHECKBOOK_ADD_BANK_ACCOUNT, CHECKBOOK_ADD_MFA_ANSWER, CHECKBOOK_ADD_MD_AMOUNTS,
        GET_PLAID_ACCOUNT_PROCESSOR_TOKEN,GET_BANK_ACCOUNT_WITH_PLAID } from "@/store/action.types";
import Loading from 'vue-loading-overlay';
import ModalsHeader from "@/components/common/modals/ModalsHeader";
import Autocomplete from "@/components/common/Autocomplete";
import {showHidePassword} from "@/mixins/showHidePassword";
import {isCapsOn} from "@/mixins/isCapsOn";
import FPButtonLoader from "@/components/common/FPButtonLoader";
import CurrencySign from '@/components/common/CurrencySign';
import { PLAID_ENV } from '@/common/config';
import PlaidLink from "vue-plaid-link";
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "addBankAccount",
  components: {
    Loading,
    PlaidLink,
    ModalsHeader,
    Autocomplete,
    'f-p-button-loader': FPButtonLoader,
    CurrencySign
  },
  mixins: [
    showHidePassword,
    isCapsOn
  ],
  computed: {
    ...mapGetters([
      'currency'
    ])
  },
  data() {
    return {
      verificationType: '',
      bluredProp: '',
      linkToken:'',
      plaid_env:PLAID_ENV,
      linkTokenError:false,
      plaidError:'',
      bankLinkingLoading:false,
      hidePlaidButton:false,
      step7Start:false,
      smallHeader:false,
      step1: true,
      step5: false,
      step6: false,
      step7: false,
      accounts: [],
      accountTypes: [
        {
          name: 'Checking',
          value: 'CHECKING'
        },
        {
          name: 'Savings',
          value: 'SAVINGS'
        }
      ],
      selectedAccountType: {},
      accountNumber: '',
      routing: '',
      mfa: [],
      mfaAmount1: '',
      mfaAmount2: '',
      verifyingInProgress: false,
      rerender: 0,
      loading: false,
      bankAccountAdded: false
    }
  },
  methods: {
    ...mapActions({
      getBankInstitutionsAction: GET_BANK_INSTITUTIONS,
      checkbookLoginToBankAction: CHECKBOOK_LOGIN_TO_BANK,
      checkbookAddBankAccountAction: CHECKBOOK_ADD_BANK_ACCOUNT,
      checkbookAddMfaAnswerAction: CHECKBOOK_ADD_MFA_ANSWER,
      checkbookAddMDAmounts: CHECKBOOK_ADD_MD_AMOUNTS,
      getPlaidAccountProcessorToken:GET_PLAID_ACCOUNT_PROCESSOR_TOKEN,
      getBankAccountWithPlaid:GET_BANK_ACCOUNT_WITH_PLAID,
    }),
    show(verifying, instantVerifying,linkToken,linkTokenError=false) {
      this.verifyingInProgress = verifying;
      if(this.verifyingInProgress && instantVerifying) {
        this.step1 = false;
        this.step6 = true;
      }
      this.linkToken = linkToken;
      this.linkTokenError=linkTokenError;
      this.$modal.show(this.$lang.messages.addBankAccountModal);
    },
    hideAddBankAccountModal() {
      this.handleCloseBankAccountModal();
      this.$modal.hide(this.$lang.messages.addBankAccountModal);
    },
    clearBankAccountData() {
      this.verificationType = '';
      this.step1 = true;
      this.step5 = false;
      this.step6 = false;
      this.step7 = false;
      this.linkToken = '',
      this.linkTokenError = false,
      this.hidePlaidButton = false;
      this.step7Start = false;
      this.smallHeader = false;
      this.plaidError = '',
      this.bankLinkingLoading = false,
      this.selectedAccountType = {};
      this.accountNumber = '';
      this.routing = '';
      this.mfaAmount1 = '';
      this.mfaAmount2 = '';
      this.loading = false;
      this.bankAccountAdded = false;
    },
    handleCloseBankAccountModal() {
      if (this.bankAccountAdded) {
        this.$emit("getRegistrationProgress");
        this.$emit("loadBankAccounts", true);
        this.bankAccountAdded = false;
      }
      if (this.step6) {
        this.$emit("loadBankAccounts", true);
      }
      this.clearBankAccountData();
      this.$emit('handleCloseBankAccountModal')
    },
    onPublicTokenError(error){
      if(error){
        this.$snotify.error(this.$lang.messages.plaidErrorMessage,"Plaid Error");
      }
    },
    handleClick(openPlaidModal){
      openPlaidModal();
      this.step1 = false;
      this.hidePlaidButton = true;
      this.step7 = true;
      this.step7Start = true;
    },
     handlePlaidOpenEvent(eventName){
       if(eventName==='OPEN'){
         this.bankLinkingLoading = true;
         this.smallHeader = true;
       }
       if(eventName==='EXIT'){
         this.step7Start = false;
         this.step7 = false;
         this.hidePlaidButton = false;
         this.step1 = true;
       }
    },
    onPublicTokenFetched(public_token,metadata){
      this.getPlaidAccountProcessorToken({publicToken:public_token,accountId:metadata.account_id}).then(response=>{
        this.getBankAccountWithPlaid({processor_token:response.data.data.processor_token}).then(response=>{
          const bankAccount = response.data.data.accounts[0];
          this.checkbookAddBankAccountAction({
            account: bankAccount.account,
            routing: bankAccount.routing,
            type: bankAccount.name.includes('Checking')?"CHECKING":"SAVINGS"
          })
          .then(() => {
            this.bankLinkingLoading = false;
            this.step7Start = false;
            this.bankAccountAdded = true;
            setTimeout(() => {
                this.hideAddBankAccountModal();
            }, 1000);
          })
          .catch(() => {
            this.displayPlaidError()
          });
          
        })
        .catch(()=>{
          this.displayPlaidError()
        })
      })
      .catch(()=>{
        this.displayPlaidError()
      })
    },
    displayPlaidError(){
      this.step7Start = false;
      this.bankLinkingLoading = false;
      this.plaidError=this.$lang.messages.plaidErrorMessage;
    },
    chooseMV() {
      this.verificationType = 'mv';
      this.step1 = false;
      if (this.verifyingInProgress) {
        this.step6 = true;
      } else {
        this.step5 = true;
      }
    },
    nextStep() {
      this.rerender++;
      if (this.step5) {
        this.addBankAccount();
      } else if (this.step6) {
        this.addMicroDepositValues();
      }
    },
    addBankAccount() {
      this.$validator.validateAll('addBankAccount')
      .then((result) => {
        this.checkAnyInput();

        let accountTypeValid = true;
        if (this.step5 && this.selectedAccountType.value === undefined) {
          accountTypeValid = false;
          this.$refs.autocompleteAccountType.createError()
        }
  
        if (result && this.verificationType === 'mv' && accountTypeValid) {
          this.loading = true;
          this.checkbookAddBankAccountAction({
            account: this.accountNumber,
            routing: this.routing ,
            type: this.selectedAccountType.value
          })
          .then(() => {
            if (this.step5) {
              this.step5 = false;
              this.step6 = true;
              this.$parent.setIsBankAccountSkipped(true);
            }
            this.loading = false;
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.response.data.status.desc, 'ERROR');
            }
          });
        }
      });
    },
    addMicroDepositValues() {
      this.$validator.validateAll('addBankAccount')
      .then((result) => {
        this.checkAnyInput();
        
        let microDepositValidation = true;
        if (this.mfaAmount2 === '') {
          this.createError('mfaAmount2', 'addBankAccount');
          microDepositValidation = false;
        }

        if (result && microDepositValidation) {
          this.loading = true;
          const amount1 = '0.' + this.mfaAmount1;
          const amount2 = '0.' + this.mfaAmount2;
          this.checkbookAddMDAmounts({
            amount_1: amount1,
            amount_2: amount2
          })
          .then(() => {
            this.loading = false;
            this.bankAccountAdded = true;
            this.$snotify.success(this.$lang.messages.sn_bankAccountAdded, 'SUCCESS');
            this.hideAddBankAccountModal();
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.response.data.status.desc, 'ERROR');
            }
          });
        }
      });
    },
    createError(name, scope) {
      let errorMsg = this.$lang.messages.vee_the + this.$lang.messages.amount.toLowerCase() + this.$lang.messages.vee_requiredField;
      this.$validator.errors.add({
        field: name,
        scope: scope,
        msg: errorMsg
      });
    },
    onSelectAccountType(value) {
      if (value) {
        this.selectedAccountType = value;
      }
    },
    clearInputErrors(e) {
      if (e.target) {
        this.$validator.errors.remove('addBankAccount.' + e.target.name)
      } else {
        this.$validator.errors.remove('addBankAccount.' + e)
      }
    },
    checkAnyInput() {
      this.bluredProp = ''
    },
    clearOthers(e) {
      this.bluredProp = e.target.name;
    }
  },
};
</script>
